export default __webpack_public_path__ + "static/media/p-get-started-img-02.7ee9b39e.png";